export default "__VITE_ASSET__Cz9Av2NZ__"